
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   MEMBER_ACTION, 
   GET_MEMBERDETAILS
} from 'Actions/types';


export const getMemberDetails = (id) => async (dispatch) => {
    
    var payload={
        "id":id
    }
    
    dispatch({ type: MEMBER_ACTION });
    return axios.post(AppConfig.apiurl+'/api/getstudentdetails', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;      
            dispatch({ type: GET_MEMBERDETAILS });            
            return Promise.resolve(resdata);
         }       
         
     })
     .catch( error => { 

     });
}

export const checkStudentAge = (id) => async (dispatch) => {
    
    var payload={
        "id":id
    }
    
    dispatch({ type: MEMBER_ACTION });
    return axios.post(AppConfig.apiurl+'/api/getstudentage', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;      
            dispatch({ type: GET_MEMBERDETAILS });            
            return Promise.resolve(resdata);
         }       
         
     })
     .catch( error => { 

     });
}



